<div class="container">
	@if (fileUploadingInProgress) {
	<mat-progress-bar
		class="progress"
		mode="indeterminate"
	></mat-progress-bar>
	}
	<br />
	<input type="file" name="file" ng2FileSelect [uploader]="uploader" />
	<button
		mat-raised-button
		color="primary"
		(click)="uploadFile()"
		class="btn btn-default"
		[disabled]="
			!uploader.getNotUploadedItems().length || fileUploadingInProgress
		"
	>
		{{ uploadButtonText | translate: lang }}
	</button>
</div>
